import Vue from 'vue';
import store from '@/store';
import MediaInfoProxy from "../../../proxies/MediaInfoProxy";
import MediaProxy from "../../../proxies/MediaProxy";
import ExcelFileProxy from "../../../proxies/ExcelFileProxy";
import * as types from './mutation-types';

/**
 * 매체 리스트
 * @param commit
 * @param param
 */
export const findAll = ({ commit }, param) => {
  new MediaInfoProxy(param)
    .all()
    .then((response) => {
      commit(types.LIST, response);
    });
};

/**
 * 매체 등록
 * @param commit
 * @param param
 */
export const createMediaInfo = ({ commit }, param) => {
  new MediaInfoProxy()
    .create(param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'MediaManagement'
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 매체 수정
 * @param commit
 * @param param
 */
export const editMediaInfo = ({ commit }, param) => {
  new MediaInfoProxy()
    .update(param.mediaInfoSeq, param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'MediaManagement',
          params: {searchName: param.searchName, searchMediaType: param.searchMediaType}
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 엑셀 업로드 완료
 * @param commit
 * @param param
 */
export const uploadComplete = ({ commit }, param) => {
  new MediaProxy()
    .uploadComplete(param)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        Vue.router.push({
          name: 'MediaExcelList'
        });
      } else {
        alert(response.header.resultMessages);
      }
    });
};

/**
 * 엑셀 파일 리스트
 * @param commit
 * @param param
 */
export const findAllExcelFiles = ({ commit }, param) => {
  new ExcelFileProxy(param)
    .all()
    .then((response) => {
      commit(types.EXCEL_FILE_LIST, response);
    });
};

/**
 * 엑셀파일 삭제
 * @param commit
 * @param excelFileSeq
 */
export const deleteExcelFile = ({ commit }, excelFileSeq) => {
  new ExcelFileProxy()
    .destroy(excelFileSeq)
    .then((response) => {
      if(response.header.returnCode === "OK") {
        let param = {
          page: 1,
          rows: 10
        };
        store.dispatch('media/findAllExcelFiles', param);
      } else {
        alert(response.header.resultMessages);
      }

    });
};

export default {
  findAll,
  createMediaInfo,
  editMediaInfo,
  uploadComplete,
  findAllExcelFiles,
  deleteExcelFile,
};
